import styled from "styled-components";

export const ImageItem = styled.img`
  width: 100%;
  border-radius: 5px;
`;

export const Spinner = styled.div`
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
  margin-left: 100px;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

    @media (max-width: 550px) {

      margin-left: 70px;
  }
`;

export const Submenu = styled.div`
  position: absolute;
  top: 10px; /* Adjust top positioning for spacing */
  left: 0; /* Align to the left of the container */
  background-color: black;
  width: 250px;
  max-height: 300px; /* Set a fixed maximum height */
  overflow-y: auto; /* Enable vertical scrolling */
  overflow-x: hidden;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 10px;
  border-radius: 10px;
  justify-content: center;
  align-items: center;

  &::-webkit-scrollbar {
    width: 8px; /* Width of the scrollbar */
  }

  &::-webkit-scrollbar-track {
    background: black; /* Background color for the scrollbar track (white) */
    border-radius: 10px; /* Rounded corners for the track */
  }

  &::-webkit-scrollbar-thumb {
    background-color: white; /* Black color for the scrollbar thumb */
    border-radius: 10px; /* Rounded corners */
  }
  @media (max-width: 550px) {


         width: 100%;
    max-height: 200px;
  }
`;

export const SubmenuLogo = styled.div`
  position: absolute;
  top: 60px;
  right:80px;
  background-color: black;
  width: 200px;
  max-height: 350px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 10px;
  border-radius: 10px;
  @media (max-width: 460px) {
   /* This may not work as intended, consider using width instead */
    width: 50%;
  }
`;

export const SizeOptions = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: transparent; /* Make the background transparent */
  border: 2px solid white; /* White border around the rectangle */
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
`;

export const SizeOption = styled.div`
  display: flex;
  align-items: center;
  margin-left: 5px;
`;

export const PositionOptions = styled.div`
  display: grid;
  width: 190px;
  grid-template-columns: repeat(2, 1fr); /* Create a 2x2 grid */
  row-gap: 70px;
  column-gap: 65%;
  background-color: transparent;
  border: 2px solid white;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
  @media (max-width: 460px) {
    width: 100%;
    column-gap: 65%;
    row-gap:50px;
  }
`;

export const PositionOption = styled.div`
  display: flex;
  align-items: center;
  
`;

export const PositionLabel = styled.label`
  margin-left: 5px;
  font-size: 14px;
`;

export const SizeLabel = styled.label`
  margin-left: 5px;
  font-size: ${(props) =>
    props.size === "small"
      ? "12px"
      : props.size === "medium"
      ? "14px"
      : "16px"};
`;

export const RadioButton = styled.input`
  width: ${(props) =>
    props.value === "small"
      ? "12px"
      : props.value === "medium"
      ? "16px"
      : "20px"};
  height: ${(props) =>
    props.value === "small"
      ? "12px"
      : props.value === "medium"
      ? "16px"
      : "20px"};
`;
export const Dropdown = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  @media (max-width: 500px) {
    width: 97%;
  }
  @media (max-width: 460px) {
    width: 150%;
  }
  @media (min-width: 348px) and (max-width: 400px) {
    width: 140%;
  }
  @media (max-width: 395px) {
    width: 130%;
  }
  @media (max-width: 369px) {
    width: 120%;
  }
`;

export const LogoPositionLabel = styled.label`
  color: var(--white);
`;

export const ApplyButton = styled.button`
  background-color: white;
  color: black;
  padding: 10px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 10px;
  &:hover {
    background-color: lightgray;
  }

  @media (max-width: 550px) {
    max-height: 50px;
  
  }
`;


export const Containerframes = styled.div`
  height: 360px; /* Adjust height to fit both components */
  width: 250px;
  position: absolute;
  top: 70px;
  right: 40px;
  background-color: black;
  border-radius: 10px; /* Rounded corners for the container */
  overflow: hidden; /* Prevent overflow */
  @media (max-width: 550px) {
  
        width: 50%;
    max-height: 250px;
  }
`;



export const AddDecorationButton = styled.button`
  position: absolute;
  bottom: 0.5px; /* Position button at the bottom of the container */
  left: 0; /* Align to the left of the container */
  width:250px;
  padding: 10px 15px; // Button padding
   font-size: 16px;
  background-color: ${({ disabled }) =>
    disabled ? "lightgray" : "white"}; // Change background if disabled
  color: ${({ disabled }) => (disabled ? "darkgray" : "black")}; /

   border: none;
  border-radius: 5px; // Rounded corners
  transition: background-color 0.3s; // Smooth transition for background color
   cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
 &:hover {
    background-color: lightgray;
  }
      @media (max-width: 550px) {
     left: 0;
     width: 100%;
  
    
  }
`;


export const CenterIcon = styled.div`
  position: absolute;
  top: 65%;
  left: 53%;
  transform: translate(-50%, -50%);
  color: white;
`;